import { useTemplatesContext } from '../components/Templates/TemplatesContext';
import { useWixFlowContext } from '../components/WixFlow/WixFlowContext';
export const useNext = () => {
  const {
    next
  } = useWixFlowContext();
  const {
    setIsPageLoading
  } = useTemplatesContext();
  return function (answers, metadata) {
    if (answers === void 0) {
      answers = {};
    }
    if (metadata === void 0) {
      metadata = {};
    }
    setIsPageLoading(true);
    next(answers, metadata);
  };
};
//# sourceMappingURL=useNext.js.map